import type { Schema } from '@dealdesk/api-schema';
import { z } from 'zod';

import { M } from '@/business';

export const bankSettingsSchema = z.object({
  submissionCutoff: z.string({ error: M.required }).regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'validation.time'),
  /** Empty = use the default warning window. */
  liabilityLetterWarningDays: z.string().regex(/^(\d{1,2})?$/, 'validation.wholeNumber'),
  calendar: z.string({ error: M.required }).trim().min(1, M.required),
});
export type BankSettingsValues = z.infer<typeof bankSettingsSchema>;

export const toBankSettingsValues = (b: Schema<'BankDetail'>): BankSettingsValues => ({
  submissionCutoff: b.submissionCutoff,
  liabilityLetterWarningDays: b.liabilityLetterWarningDays == null ? '' : String(b.liabilityLetterWarningDays),
  calendar: b.calendar ?? '',
});

export const toBankSettingsInput = (v: BankSettingsValues) => ({
  submissionCutoff: v.submissionCutoff,
  liabilityLetterWarningDays: v.liabilityLetterWarningDays === '' ? null : Math.trunc(Number(v.liabilityLetterWarningDays)),
  calendar: v.calendar.trim(),
});

export const schemeSchema = z.object({
  code: z.string({ error: M.required }).trim().regex(/^[A-Z0-9_]{2,16}$/, 'validation.code'),
  name: z.string({ error: M.required }).trim().min(1, M.required),
  nameAr: z.string().optional(),
  effectiveFrom: z.string().optional(),
  note: z.string().optional(),
});
export type SchemeValues = z.infer<typeof schemeSchema>;
export const schemeDefaults: SchemeValues = { code: '', name: '', nameAr: '', effectiveFrom: '', note: '' };
export const toSchemeInput = (v: SchemeValues): Schema<'SchemeInput'> => ({
  code: v.code.trim(),
  name: v.name.trim(),
  nameAr: v.nameAr?.trim() || null,
  ...(v.effectiveFrom ? { effectiveFrom: v.effectiveFrom } : {}),
  ...(v.note?.trim() ? { note: v.note.trim() } : {}),
});
